<template>
  <div class="imgBox" v-show="templateThumbnailList.length !== 0">
    <div class="img">
      <!-- + '?x-sds-process=image/resize,l_88,m_lfit' -->
      <el-image ref="elImg" style="width:100%;height:100%;" :preview-src-list="templateThumbnailList" v-if="templateThumbnailList[0]" :src="templateThumbnailList[0]" fit="fill"></el-image>
    </div>
    <div class="img" v-if="templateThumbnailList.length === 2">
      <!-- + '?x-sds-process=image/resize,l_88,m_lfit' -->
      <el-image style="width:100%;height:100%;" :preview-src-list="templateThumbnailList" v-if="templateThumbnailList[1]" :src="templateThumbnailList[1]" fit="fill"></el-image>
    </div>
  </div>
</template>
<script>
import { INSPECT_MAX_BYTES } from 'buffer'

export default {
  name: 'templateThumbnail',
  props: {
    templateGroup: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      templateThumbnailList: []
    }
  },
  watch: {
    templateGroup: {
      handler (val, oldVal) {
        console.log(val, 'val')
        this.init(val)
      },
      immediate: true
    }
  },
  methods: {
    init (item) {
      console.log(item, 'item加载数据', item.templates)
      this.templateThumbnailList = []
      if (!item.templates || item.templates.length === 0) {
        return
      }
      item.templates.forEach(v => {
        this.templateThumbnailList.push(v.templateThumbnail)
      })
      // if (item.propertyId === 2) {
      //   this.templateThumbnailList = [item.templates[0].templateThumbnail]
      // } else {
      //   this.templateThumbnailList = item.templates.reduce((list, temp) => {
      //     list[temp.templatePosition] = temp.templateThumbnail
      //     return list
      //   }, [])
      // }
      console.log('this.templateThumbnailList', this.templateThumbnailList)
    },
    checkImg () {
      this.$refs.elImg.$el.children[0].click()
    }
  }
}
</script>
<style lang="less" scoped>
.imgBox {
  float: left;
  width: 100%;
  display: flex;
  justify-content: space-around;

  .img {
    flex: 1;
    // border: 1px solid #000;
  }
}
</style>
